import { ReactNode, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
    children: ReactNode,
    wrapperId: string
}

export default function Portal({ children, wrapperId }: PortalProps) {
    const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null);

    useLayoutEffect(() => {
        let element = document.getElementById(wrapperId);
        let created = false;

        if(!element) {
            created = true;
            element = createElement(wrapperId);
        }
        setWrapperElement(element);

        return () => {
            if(created && element?.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }, [wrapperId])

    if(wrapperElement === null) return null;

    return createPortal(children, wrapperElement);
}

function createElement(wrapperId: string) {
    const wrapperElement = document.createElement('div');
    wrapperElement.setAttribute("id", wrapperId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}